
import React from "react";
import { Calendar, BookOpen, Pencil, Settings, Bell, Star, HelpCircle } from "lucide-react";
import { useAdminCheckQuery } from "@/hooks/useAdminCheckQuery";
import { useServiceEditAccess } from "@/hooks/useServiceEditAccess";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarRail,
} from "@/components/ui/sidebar";

interface VendorSidebarProps {
  activeView: string;
  serviceId: string;
  onViewChange: (view: string) => void;
}

export const VendorSidebar: React.FC<VendorSidebarProps> = ({
  activeView,
  serviceId,
  onViewChange,
}) => {
  const { data: isAdmin } = useAdminCheckQuery();
  const { showEditInSidebar } = useServiceEditAccess(serviceId);

  const menuItems = [
    {
      view: "calendar",
      label: "Calendar",
      icon: Calendar,
      visible: true
    },
    {
      view: "bookings",
      label: "Bookings",
      icon: BookOpen,
      visible: true
    },
    {
      view: "reviews",
      label: "Reviews",
      icon: Star,
      visible: true
    },
    {
      view: "edit",
      label: "Edit Service",
      icon: Pencil,
      visible: showEditInSidebar
    },
    {
      view: "settings",
      label: "Settings",
      icon: Settings,
      visible: true
    },
    {
      view: "help",
      label: "Help",
      icon: HelpCircle,
      visible: true
    }
  ];

  const visibleItems = menuItems.filter(item => item.visible);

  return (
    <Sidebar collapsible="icon" className="bg-white border-r mt-16">
      <SidebarContent className="bg-white pt-4">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {visibleItems.map((item) => (
                <SidebarMenuItem key={item.view}>
                  <SidebarMenuButton 
                    onClick={() => onViewChange(item.view)}
                    isActive={activeView === item.view}
                    tooltip={item.label}
                    className="bg-white hover:bg-gray-100 data-[active=true]:bg-primary data-[active=true]:text-primary-foreground"
                  >
                    <item.icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
};
